import React from 'react';
import './CTASection.css';

const CTASection = ({ title, description, variant = 'primary' }) => {
  return (
    <section className={`cta-section cta-${variant}`}>
      <div className="container">
        <div className="cta-content">
          <h2 className="cta-title">{title}</h2>
          {description && <p className="cta-description">{description}</p>}
          <div className="cta-buttons">
            <button className="btn-primary">Get Started</button>
            <button className="btn-secondary">Learn More</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;

